export default __webpack_public_path__ + "media/zurb/img/product-innovation/patelco_video_screenshot-09eaa6790f11bec253b715d2c1b65483.png";